module.exports = __webpack_public_path__ + "assets/AdultAccidentTemplate-6e31afe71196735b30c6c771791fd0b4.xlsx";